import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { 
    faPlus, 
    faPencil, 
    faTrash, 
    faArrowUpRightFromSquare, 
    faHouse,
    faBuilding,
    faIndustry,
    faRobot,
    faFile,
    faBug,
    faCloud,
    faCircleExclamation,
    faArrowRightToBracket,
    faArrowRightFromBracket,
    faXmark,
    faFilePen,
    faShuffle,
    faChartGantt,
    faCircleCheck,
    faCircleXmark,
    faCircleQuestion,
    faBan,
    faNewspaper,
    faFilter
} from '@fortawesome/free-solid-svg-icons';

export function setupFontawesome() {
    library.add(faPlus, faPencil, faTrash, 
        faArrowUpRightFromSquare, faHouse, faBuilding, 
        faIndustry, faRobot, faFile, faBug,
        faCloud, faCircleExclamation, faArrowRightToBracket,
        faArrowRightFromBracket, faXmark, faFilePen,
        faShuffle, faChartGantt, faCircleCheck, faCircleXmark,
        faCircleQuestion, faBan, faNewspaper, faFilter
    );
    dom.watch();
}